import { Grid, Typography } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import { graduationRequests } from "api/graduationApi";
import BackButtonToolbar from "features/BackButtonToolbar";
import React, { useCallback, useEffect, useState } from "react";
import { Labeled, ReferenceField, Show, SimpleShowLayout, TextField } from "react-admin";
import dataProvider from "server/dataProvider";
import { useParams } from "react-router";
import FinalizeInternshipSessionDialog from "./FinalizeInternshipSessionDialog";
import { studentRequests } from "api/studentApi";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";

const ShowInternshipSessions = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const { id } = useParams();
  const [isFinalized, setIsFinalized] = useState(null);

  const checkIsFinalized = useCallback(async () => {
    try {
      await dataProvider.customRequest(graduationRequests.checkInternshipSessionFinalization(id));
      setIsFinalized(true);
    } catch (err) {
      if (err.status === 404) {
        setIsFinalized(false);
      }
      console.error(err);
    }
  }, [id]);

  useEffect(() => {
    if (!id) return;
    checkIsFinalized();
  }, [id, checkIsFinalized]);

  return (
    <Show
      title="Детайли на сесия"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Учебна година">
              <ReferenceField
                source="academicYearId"
                reference={studentRequests.getAcademicYearsSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Структурна единица">
              <ReferenceField
                source="structuralUnitId"
                reference={administrationRequests.getStructuralUnitsSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Тип">
              <ReferenceField
                source="type"
                reference={graduationRequests.getInternshipSessionTypesSelect()}
              >
                <TextField source="nameBg" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Начална дата">
              <TextField source="startDate" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Крайна дата">
              <TextField
                source="endDate"
                label="Крайна дата"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            {!isFinalized ? (
              <FinalizeInternshipSessionDialog
                id={id}
                checkIsFinalized={checkIsFinalized}
              />
            ) : (
              <Typography
                color="error"
                mt={2}
              >
                ФИНАЛИЗИРАНА
              </Typography>
            )}
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowInternshipSessions;
